import { css } from "@linaria/core";
import Button from "@ui/Button";
import { colors, fonts, spacings } from "@ui/Theme";
import React from "react";
import t from "../../../../../../../../i18n";
import SurveyLine from "@ui/IconV2/react/SurveyLine";
import Text from "@ui/Text";
import { Markdown } from "@ui/Markdown";

interface ActionIdentidiedProps {
  text: string;
  onClick?: () => void;
}

const ActionIdentidiedCard = ({ text, onClick }: ActionIdentidiedProps) => (
  <div className={lastCommentCard}>
    <div className={title}>
      <span className={titleName}>
        <SurveyLine color={colors.carbon800} />
        <p>{t("project.event.header.card.action_identified.title.text")}</p>
      </span>
      {onClick === undefined ? null : (
        <Button variant="link" onClick={onClick}>
          {t("project.event.header.card.action_identified.update.text")}
        </Button>
      )}
    </div>
    <div className={content}>
      <Text type="body1" className={markdown}>
        <Markdown defaultValue={text} />
      </Text>
    </div>
  </div>
);

export default ActionIdentidiedCard;

//#region CSS
const lastCommentCard = css``;

const title = css`
  display: flex;
  align-items: center;
  gap: ${spacings.xs};
`;
const titleName = css`
  display: inline-flex;
  align-items: center;
  gap: ${spacings.xxs};
  color: ${colors.carbon800};
  p {
    font: ${fonts.body1SemiBold};
  }
`;
const content = css`
  display: flex;
  flex-direction: column;
  gap: ${spacings.xs};
  color: ${colors.carbon800};
  margin-top: ${spacings.m};

  strong {
    color: ${colors.carbon900};
  }
`;

const markdown = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  p {
    @supports (-webkit-line-clamp: 4) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }
  }
`;
//#endregion CSS
